<!-- static content data from lang: question -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
      <base-header class="pb-6">
        <div class="row align-items-center pb-4">
          <div class="col-lg-12 col-12">
            <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.EditheaderTitle}}</h6>
            <nav aria-label="breadcrumb" class="d-inline-block ml-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </div>
        </div>
      </base-header>
      <div class="container-fluid mt--6">
        <div>
          <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
            <div class="col-md-12">
              <template v-for="(message) in alertMessages">
                <Alert :type = alertType dismissible  v-if="message" :key="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <template v-for="(message) in successMessages">
                <Alert :type = successType dismissible  v-if="message" :key="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-md-12">
                          <base-input
                            alternative
                            :label="lang.label.name"
                            class="mb-3"
                            :rules="{required: true}"
                            name="group name"
                            prepend-icon="fas fa-users"
                            :placeholder="lang.label.name"
                            v-model="model.groupName"
                            labelClasses="form-control-label asterisk-mark"
                            autocomplete="off"
                          ></base-input>
                        </div>
                        <template v-if="addMember">
                          <div class="col-md-12">
                          <template v-for="(person,index) in personInfo">
                            <div :key="index">
                              <div class="form-group">
                                <div class="col-lg-6 pl-0">
                                  <base-input
                                    alternative
                                    :label="lang.label.personName"
                                    class="mb-3"
                                    :rules="{required: true}"
                                    :name="'person- '+(index+1)+'\'s name'"
                                    prepend-icon="fas fa-users"
                                    :placeholder="lang.label.personName"
                                    v-model="person.name"
                                    labelClasses="form-control-label asterisk-mark"
                                    autocomplete="off"
                                  ></base-input>
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="col-lg-6 pl-0">
                                  <base-input
                                    :label="lang.label.relationship"
                                    :name="'person- '+(index+1)+'\'s relation type'"
                                    rules="required"
                                    labelClasses="form-control-label asterisk-mark"
                                  >
                                    <el-select
                                      v-model="person.relation"
                                      autocomplete="off"
                                      :placeholder="lang.label.selectRelationType"
                                      filterable
                                    >
                                      <el-option
                                        v-for="(option,index) in sortedRelationTypes"
                                        :key="index"
                                        :label="option.Name"
                                        :value="option.ID"
                                      ></el-option>
                                    </el-select>
                                  </base-input>
                                </div>
                              </div>
                              <div class="form-group" v-if="person.photo">
                                <base-input
                                  :label="lang.label.changeLogo"
                                  name="change photograph"
                                  :rules="{required: true}"
                                >
                                  <b-form-group class="mb-0">
                                    <b-form-radio-group
                                      :id="'radio-group'+index"
                                      v-model="changePhotos[index]"
                                      autocomplete="off"
                                      :options="options"
                                      :name="'radio-group'+index"
                                    ></b-form-radio-group>
                                  </b-form-group>
                                </base-input>
                              </div>
                              <div class="form-group photo-upload">
                                <div class="row">
                                  <div class="col-3" v-if="person.photo ? changePhotos[index] == 'Yes' : true">
                                    <base-input
                                      :name="'person- '+(index+1)+'\'s photo'"
                                      labelClasses="form-control-label asterisk-mark"
                                      :rules="$refs.extraPerson && $refs.extraPerson[index] ?($refs.extraPerson[index].dropzone.files.length ? '': {required: true}) : ''"
                                      :label="lang.label.uploadThePhoto">
                                      <vue-dropzone
                                        ref="extraPerson"
                                        id="extraPerson"
                                        :options="dropzoneOptions"
                                        class="textFile"
                                        v-model="person.photo"
                                        autocomplete="off"
                                        @vdropzone-file-added="filesAdded"
                                        @vdropzone-success="fileSuccess"
                                        @vdropzone-removed-file="filesRemoved"
                                      ></vue-dropzone>
                                    </base-input>
                                  </div>
                                  <div class="col-4 pt-4 pl-3">
                                    <img  v-if="!photosAdded[index] && person.photo" height="150px" :src="person.photo" alt="company logo">
                                  </div>
                                </div>
                              </div>
                              <hr v-if="index != personInfo.length-1">
                            </div>
                          </template>
                          <div class="pt-4 pb-2">
                            <label for="otherPersons">{{lang.label.addPerson}}</label>
                            <span class="pl-3" title="add a person"><a @click="addPerson" href="javascript:void(0)"><i class="fas fa-user-plus"></i></a></span>
                          </div>
                        </div>
                        </template>
                        <div class="col-12 text-center text-lg-left">
                          <div class="row">
                            <div
                              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                            >
                              <el-select
                                class="select-primary pagination-select"
                                v-model="pagination.perPage"
                                autocomplete="off"
                                placeholder="Per page"
                              >
                                <el-option
                                  class="select-primary"
                                  v-for="item in pagination.perPageOptions"
                                  :key="item"
                                  :label="item"
                                  :value="item"
                                ></el-option>
                              </el-select>

                              <div>
                                <base-input
                                  v-model="searchQuery"
                                  autocomplete="off"
                                  prepend-icon="fas fa-search"
                                  :placeholder="lang.label.search"
                                ></base-input>
                              </div>
                            </div>
                          </div>
                          <div class="text-right mb-3">
                            <base-button
                              type="primary"
                              @click="addNewGroupMember"
                            >{{lang.label.buttons.AddNewMember}}</base-button>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            border
                          >
                            <!--                  <el-table-column width="150px" label="Name" prop="Name" sortable></el-table-column>-->
                            <el-table-column min-width="200px" label="Name" sortable prop="Name">
                              <div class="d-flex" slot-scope="scope" v-html="scope.row.Name"></div>
                            </el-table-column>
                            <el-table-column min-width="200px" label="Relationship type" sortable prop="RelationshipType">
                              <div class="d-flex" slot-scope="scope" v-html="scope.row.RelationshipType"></div>
                            </el-table-column>
                            <el-table-column min-width="150px" label="Photograph" sortable prop="Photograph">
                              <div class="d-flex" slot-scope="scope">
                                <img height="70px" width="70px" :src="getPhoto(scope.row.Photograph)" alt="">
                              </div>
                            </el-table-column>
                            <el-table-column width="100px" align="right" label="Actions" prop="ID">
                              <div class="d-flex" slot-scope="scope">
                                <el-tooltip :content="lang.label.tooltips.delete" placement="bottom">
                                  <base-button
                                    class="btn-link"
                                    type="danger"
                                    size="sm"
                                    icon
                                    @click.native="showSwal(scope.row.ID)"
                                  >
                                    <i class="text-white fas fa-trash-alt"></i>
                                  </base-button>
                                </el-tooltip>
                              </div>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                      <div class="col-12 mt-3 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class>
                          <p class="card-category">
                            {{lang.label.showPagination.showing}} {{ from + 1 }} {{lang.label.showPagination.to}} {{ to }} {{lang.label.showPagination.of}} {{ total }} {{lang.label.showPagination.entries}}
                            <span
                              v-if="selectedRows.length"
                            >&nbsp; &nbsp; {{selectedRows.length}} {{lang.label.showPagination.rowsSelected}}</span>
                          </p>
                        </div>
                        <base-pagination
                          class="pagination-no-border"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="total"
                        ></base-pagination>
                      </div>
                    </div>
                  </div>
                  <div class="text-right mb-3">
                    <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                    <base-button
                      type="danger"
                      @click="$router.push({name: 'groupManagement'})"
                    >{{lang.label.buttons.cancel}}</base-button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import HtmlEditor from '@/components/Inputs/HtmlEditor'
    import Alert from "@/components/BaseAlert.vue";
    import clientPaginationMixin from "../../Tables/PaginatedTables/clientPaginationMixin";
    import { Table, TableColumn, Select, Option } from "element-ui";
    import state from "../../../store/state";
    import swal from "sweetalert2";
    export default {
        mixins: [clientPaginationMixin],
        components: {
            RouteBreadCrumb,HtmlEditor,
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            Alert,
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                addMember: false,
                personInfo: [{name: '', relation: '', photo: ''}],
                lang: this.$lang.group_management,
                visitorID: '',
                propsToSearch: ["Name", "RelationshipType"],
                selectedRows: [],
                tableData: [],
                groupId: '',
                fileObject: [],
                uploading:false,
                relationTypes: [
                    {ID: 0, Name: 'Other'},
                    {ID: 1, Name: 'Son'},
                    {ID: 2, Name: 'Daughter'},
                    {ID: 3, Name: 'Friend'},
                    {ID: 4, Name: 'Father'},
                    {ID: 5, Name: 'Pupil'},
                    {ID: 6, Name: 'Tourist'},
                    {ID: 7, Name: 'Mother'},
                    {ID: 8, Name: 'Colleague'},
                    {ID: 9, Name: 'Spouse'},
                    {ID: 10, Name: 'Supplier'},
                ],
                selects: {
                    simple: "Select"
                },
                numberOfPersons: 1,
                photosAdded: [],
                options: [
                    { text: "Yes", value: "Yes" },
                    { text: "No", value: "No" }
                ],
                dropzoneOptions: {
                    url: "https://httpbin.org/post",
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    uploadMultiple: false,
                    maxFilesize: 10,
                    maxFiles: 1,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    dictDefaultMessage:
                        "<div class='upload-docs'><p>Drop file here <br/>or <br/>click to upload</p></div>"
                },
                model: {
                    groupName:''
                },
                alertType: 'danger',
                successType: 'success',
                alertMessages: [],
                successMessages: [],
                loading: true,
            };
        },
        computed:{
            sortedRelationTypes(){
                return [...this.relationTypes].sort((a,b)=>{
                    const an = (a.Name || '').toString().toLowerCase();
                    const bn = (b.Name || '').toString().toLowerCase();
                    if(an < bn) return -1;
                    if(an > bn) return 1;
                    return 0;
                });
            }
        },
        mounted(){
            this.groupId = this.$route.params.id;
            this.getGroup(this.groupId);
        },
        methods: {
            addMembers(index){
                if(this.addMember) {
                    let self = this;
                    let formData = new FormData();
                    formData.append('VisitorGroupsID', this.groupId);
                    formData.append('Name', this.personInfo[index].name);
                    formData.append('Photograph', this.$refs.extraPerson[index].dropzone.files[0]);
                    formData.append('RelationshipType', this.personInfo[index].relation);
                    this.$store.dispatch('addGroupMember', formData)
                        .then(response => {
                            if (response.status == 200) {
                                if(this.personInfo.length-1 != index) {
                                    this.addMembers(index+1);
                                }else {
                                    this.successMessages.push(response.data.message);
                                    this.addMember = false;
                                    this.addMembers();
                                }
                            }else {
                                if(typeof response.data.message != 'object'){
                                    this.alertMessages.push(response.data.message);
                                    setTimeout(function () {
                                        self.alertMessages = [];
                                    }, 5000);
                                }else{
                                    var array = new Array();
                                    for (let key of Object.keys(response.data.message)) {
                                        let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                        array.push(obj)
                                    }
                                    this.alertMessages.push(array.join(', '));
                                    setTimeout(function () {
                                        self.alertMessages = [];
                                    }, 5000);
                                }
                                this.loading = false;
                            }
                        }).catch(reason => {
                        this.loading = false;
                        console.log('reason', reason);
                    })
                }else {
                    let data = {
                        "Name": this.model.groupName,
                        "groupID": this.groupId,
                        "VisitorID": this.visitorID
                    };
                    this.$store.dispatch('updateGroup', data)
                        .then(response => {
                            if (response.status == 200) {
                                this.model.groupName = '';
                                this.$store.commit('setSuccessMessage', response.data.message)
                                this.$router.push({ name: "groupManagement"});
                            }else{
                                if(typeof response.data.message != 'object'){
                                    this.alertMessages.push(response.data.message);
                                    setTimeout(function () {
                                        self.alertMessages = []
                                    },5000)
                                }else{
                                    var array = new Array();
                                    for (let key of Object.keys(response.data.message)) {
                                        let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                        array.push(obj)

                                    }
                                    this.alertMessages.push(array.join(', '));
                                    setTimeout(function () {
                                        self.alertMessage = []
                                    },5000)
                                }
                            }
                            this.loading = false;
                        })
                        .catch(error => {

                            this.loading = false;
                        })
                }
            },
            addPerson() {
                this.personInfo.push({name: '', relation: '', photo: ''});
            },
            addNewGroupMember(){
                this.addMember = !this.addMember;
            },
            showSwal(ID) {
                let self = this;
                swal.fire({
                    title: "Are you sure?",
                    text: "Do you really want to delete this record? Deleting this will also delete it's corresponding child data as well.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, keep it",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-primary btn-fill",
                        cancelButton: "btn btn-danger btn-fill"
                    }
                })
                    .then(result => {
                        if (result.value) {
                            this.loading = true;
                            this.$store
                                .dispatch("deleteVisitor", ID)
                                .then(response => {
                                    if(response.status == 200) {
                                        self.getGroup(self.groupId, response.data.message);
                                    }else {
                                        if(typeof response.data.message != 'object'){
                                            this.alertMessages.push(response.data.message);
                                            setTimeout(function () {
                                                self.alertMessages = [];
                                            },5000)
                                        }else{
                                            var array = new Array();
                                            for (let key of Object.keys(response.data.message)) {
                                                let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                                array.push(obj)
                                            }
                                            this.alertMessages.push(array.join(', '));
                                            setTimeout(function () {
                                                self.alertMessages = [];
                                            },5000)
                                            this.loading = false;
                                        }
                                    }
                                }).catch(error => {
                                this.loading = false;
                            });
                        }
                    });
            },
            getPhoto(url) {
                return state.mediaURL + url;
            },
            getGroup(id, message = '') {
                let self = this;
                this.loading = true;
                this.$store.dispatch('viewGroup', id)
                    .then(response => {
                        this.visitorID = response.data.VisitorID;
                          if(response.status == 200) {
                              this.model.groupName = response.data.Name;
                              this.tableData = response.data.Members;
                              if(message) {
                                  self.successMessages.push(message);
                                  setTimeout(function () {
                                      self.successMessages = [];
                                  }, 5000);
                              }
                          }else {
                              if(typeof response.data.message != 'object'){
                                  this.alertMessages.push(response.data.message);
                                  setTimeout(function () {
                                       self.alertMessages = [];
                                  },5000)
                              }else{
                                  var array = new Array();
                                  for (let key of Object.keys(response.data.message)) {
                                      let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                      array.push(obj)
                                  }
                                  this.alertMessages.push(array.join(', '));
                                  setTimeout(function () {
                                      self.alertMessages = [];
                                  },5000)
                              }
                          }
                        this.loading = false;
                    })
            },
            filesAdded(file){
                // this.$refs.extraPerson.removeFile(file)
                this.observeFiles();
                this.fileAdded = true;
                this.uploading = true;
            },
            fileSuccess(file) {
                this.uploading = false;
            },
            observeFiles(){
                this.photosAdded = new Array(this.numberOfPersons);
                this.$refs.extraPerson.forEach((object, index)=>{
                    this.photosAdded[index] = object.dropzone.files.length ? true : false;
                });
            },
            filesRemoved(file,error){
                this.observeFiles();
                this.fileAdded = false;
                this.uploading = false;
            },
            onSubmit() {
                this.loading = true;
                this.addMembers(0);
                this.router.push({ name: 'groupManagement' });
            },
        }
    };
</script>
<style>
  .no-border-card .card-footer {
    border-top: 0;
  }
  .modal-header {
    padding-bottom: 0;
  }
</style>
